module.exports = __webpack_public_path__ + "static/img/barrio.be24c0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/barrio.jpg
// module id = Byjh
// module chunks = 1